import axios from "axios";
import {db_url, host, url_default} from "../url";

export default function DB_Log(token) {


    const getLogs = (controller, search) => {
        return axios.get(db_url + '/development/logs', {
            signal: controller.signal,
            params: search,
            headers: {
                Authorization: token
            }
        })
    }

    const getLog = (id) => {
        return axios.get(db_url + `/development/log/${id}`, {
            headers: {
                Authorization: token
            }
        })
        // return axios.get(url_log + data, formData)
    }

    const getRequest = (type, id) => {
        return axios.get(host + `/requests/${type}/${id}.txt`)
    }



    const getDefaultValue = () => {
      return axios.get(url_default, {
          headers: {
              Authorization: token
          }
      })
    }


    return {
        getLogs,
        getLog,
        getDefaultValue,
        getRequest,
    }
}
